import { HttpClient, TunzNetworkError, Axios } from '@tunz/http';
// eslint-disable-next-line import/no-unresolved
import { FilterValuesItem } from '@tunz/data-tables';

export type Referential = { id: number; name: string } & FilterValuesItem;
const cache: {
	[index: string]: Referential[];
} = {};

const onGoingRequests: {
	[index: string]: Promise<Axios.AxiosResponse<Referential[]>>;
} = {};

const getOrFetch = async <T extends Referential = Referential>(
	refName: string,
	url: string,
	addEmptyValue = false,
	keyId: keyof T = 'id',
	keyName: keyof T = 'name',
): Promise<T[]> => {
	let returnedValues: T[] = [];
	if (cache[refName] === undefined) {
		try {
			if (onGoingRequests[refName] === undefined) {
				onGoingRequests[refName] = HttpClient.get<T[]>(url);
			}
			const request = onGoingRequests[refName];
			const response = await request;
			cache[refName] = response.data.map((r: Referential) => {
				const responseItem = r as T;
				return {
					...responseItem,
					id: responseItem[keyId],
					name: responseItem[keyName],
					key: responseItem[keyId],
					label: `${responseItem[keyId]} - ${responseItem[keyName]}`,
				};
			});
		} catch (e) {
			let { message } = e as Error;
			if (TunzNetworkError.isTunzNetworkError(e as Error)) {
				const tne = e as TunzNetworkError;
				if (tne.status === 401) {
					message = 'You are not authorized to get this resource';
				}
			}
			throw new Error(`No ${refName} found: ${message}`);
		}
	}

	// Cloning the array to prevent from modifying it if addEmptyValue is true
	returnedValues = [...cache[refName]] as T[];

	if (addEmptyValue) {
		const all: Referential = { key: 0, label: 'All', id: 0, name: 'All' };
		returnedValues.unshift(all as T);
	}
	return returnedValues;
};

export default getOrFetch;
